<template>
  <section class="content">
    <div class="row center-block">   
      <box title="">
        <div slot="body">
          <div class="row">
            <div class="col-md-2" style="display: flex">
                <router-link class="padding" to="/nova-campanha" >
                  <button class="btn btn-primary" >Nova Campanha</button>
                </router-link>
            </div>
          </div> 
          <div class="row">
            <div class="col-sm-12">
              <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
                <div class="row">
                  <div class="col-sm-6">
                    <div id="example1_length" class="dataTables_length"></div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table aria-describedby="example1_info" role="grid" id="example1"
                      class="table table-borde#F48668 table-striped dataTable">
                      <thead>
                        <tr>
                          <th v-for="coluna in colunas">
                            <a href="javascript:;" >
                              <div class="row">
                                <div class="col-sm-7">
                                  {{coluna | ucwords}}
                                </div>
                              </div>
                            </a>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="campanhas.length === 0">
                          <td colspan="12">Nenhum Pedido Localizado</td>
                        </tr>
                        <tr v-else class="even" role="row" v-for="(c, index) in campanhas">
                          <!-- <td>{{ c.id }}</td> -->
                          <td>Cupom</td>
                          <td>{{ verificarPremio(c) }}</td>
                          <td>{{ c.codigo }}</td>
                          <td>
                            <toggle-button 
                              @change="changeStatus(c.ativo, c.id)"
                              v-model="c.ativo"
                              :color="color" 
                              :sync="true" />
                            <!-- <i :class="'fa fa-circle ativo_'+c.ativo" aria-hidden="true" title=""></i> -->
                          </td>
                          <td>
                            <div class="grupo_btn_acoes">
                              <router-link :to="{name: 'Editar Campanha', params: { id: c.id}}" class="btn_editar">
                                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                              </router-link>
                              <!-- <i class="fa fa-trash-o btn_prod_excluir" aria-hidden="true" @click="excluir(c.id)"></i> -->
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </box>
    </div>
  </section>
</template>

<script>
import Box from '../Box'
import resource from './resource'

export default {
  name: 'Campanhas',
  components: {
    'box': Box
  },
  data () {
    return {
      campanhas: [],
      colunas: ['Tipo', 'Premio', 'Código Cupom', 'Ativo']
    }
  },
  created() {
    this.getCampanhas()
  },
  methods: {
    getCampanhas() {
      resource.getListaCampanhas().then(res => {
        console.log('campanhas => ', res.data);
        this.campanhas = res.data
      })
    },
    verificarPremio(campanha) {
      if(campanha.frete_gratis) return 'Frete Grátis'
      else if(campanha.dinheiro_desconto > 0) return `R$${campanha.dinheiro_desconto}`
      else if(campanha.porcentagem_desconto > 0) return `${campanha.porcentagem_desconto}%`
    },
    changeStatus(ativo, id) {
      console.log('ativo => ', ativo)
      console.log('id => ', id);
      let obj = {
        ativo: ativo,
        empresa: this.$store.state.empresa_fb_id
      };
      resource.updateCampanha(obj, id).then(res => {
        this.$swal({
          position: 'top-end',
          type: 'success',
          title: 'Gravado com sucesso',
          showConfirmButton: false,
          timer: 1500
        })
        this.getCampanhas()
      }).catch(err => {
        this.$swal(
          'Ops!',
          'Ocorreu um erro na gravação da campanha.',
          'error'
        )
        this.getCampanhas()
      })
    }
  },
  computed: {
    
  },
  filters: {
      ucwords(value) {
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// Campanhas.vue?52d436a6